import { EditorBlockView } from '@getaccept/editor-view-new';
import { Context } from '@getaccept/editor-lib-new';
import { DocumentPageType } from '@getaccept/lib-shared-new/src/enums/document-page-type';
import { computed, defineComponent } from 'vue';
import ContentLinkPage from '@getaccept/lib-shared-new/src/components/ContentLinkPage.vue';
import VideoPage from '@getaccept/lib-shared-new/src/components/VideoPage.vue';
import PDFPage from '@getaccept/lib-shared-new/src/document-view/components/PDFPage.vue';
export default defineComponent({
    name: 'Page',
    components: {
        VideoPage,
        ContentLinkPage,
        PDFPage,
        EditorBlockView,
    },
    props: {
        page: { type: Object, required: true },
        pageWidth: { type: Number, required: true },
    },
    setup(props) {
        const editorContent = computed(() => props.page.editorBlock.content);
        const isPageType = (pageType) => props.page.pageType === pageType;
        return {
            DocumentPageType,
            Context,
            editorContent,
            isPageType,
        };
    },
});
